<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-icon size="256">
          mdi-alert
        </v-icon>
      </v-col>

      <v-col cols="12" class="text-center">
        <gg-card-title>
          Multiple Affiliate Accounts Found
        </gg-card-title>
      </v-col>

      <v-col cols="12" class="subtitle-1 text-center">
        We have found multiple affiliate accounts with the email address {{ SessionProfile.email }} and we cannot automatically link
        your account. You will need to speak to our affiliate support team or your dedicated account manager to resolve
        this conflict.
      </v-col>

      <v-col cols="12" class="text-center">
        <gg-btn :to="{ name: 'support_ticketnew' }">
          Contact Support
        </gg-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MultipleAccountView',
  computed: {
    ...mapGetters(['SessionProfile'])
  }
}
</script>

<style scoped>

</style>
